import { render, staticRenderFns } from "./TabellaPreventivi.vue?vue&type=template&id=376c76d4&scoped=true&"
import script from "./TabellaPreventivi.vue?vue&type=script&lang=js&"
export * from "./TabellaPreventivi.vue?vue&type=script&lang=js&"
import style0 from "./TabellaPreventivi.vue?vue&type=style&index=0&id=376c76d4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376c76d4",
  null
  
)

export default component.exports
import QSpinnerHourglass from 'quasar/src/components/spinner/QSpinnerHourglass.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSpinnerHourglass,QTable,QInput,QIcon,QTr,QTh,QTd});
